const selectors = {
    el: '.js-load-more:not(.is-initialized)',
    results: '.js-load-more-results',
    item: '.js-load-more-item'
}

const classes = {
    loading: 'is-loading',
    loaded: 'is-loaded'
}

const loadResults = (el) => {
    fetch(el.href)
        .then(
            response => response.text(),
        )
        .then((res) => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(res, 'text/html');
            const items = doc.querySelectorAll(selectors.item);
            const loadMore = doc.querySelector(selectors.el);
            const resultsContainer = document.querySelector(selectors.results);
            
            resultsContainer.style.height = resultsContainer.offsetHeight + 'px';

            setTimeout(() => {
                items.forEach(item => {
                    resultsContainer.appendChild(item);
                });

                requestAnimationFrame(() => {
                    requestAnimationFrame(() => { // Appending takes more than 1 frame on FF
                        document.dispatchEvent(new CustomEvent('domUpdated'));

                        el.classList.remove(classes.loading);

                        requestAnimationFrame(() => {
                            resultsContainer.style.height = resultsContainer.scrollHeight + 'px';

                            if (loadMore) {
                                el.href = loadMore.href;
                            } else {
                                el.remove();
                            }
                        });
                    });
                });
            }, 400);
        })
        .catch((err) => {
            if (err.name === 'AbortError') return;
            console.warn(err);
        });
}

const init = () => {
    const els = document.querySelectorAll(selectors.el);
    els.forEach(el => {
        el.classList.add('is-initialized');

        el.addEventListener('click', (e) => {
            e.preventDefault();

            el.classList.add(classes.loading);
            loadResults(el);
        });
    });
};

const module = () => {
    init();
    document.addEventListener('domUpdated', init);
};

export default module;